import { Trip } from "../../DataStructures/Trip/Trip";
import { Vehicle } from "../../DataStructures/Vehicle/Vehicle";
import { VehicleSuggestion } from "../VehicleSuggestion/VehicleSuggestion";
import { VehicleService } from "../../services/vehicle-service/vehicle.service";
import { MatDialog } from "@angular/material";
import { Suggestion } from "../VehicleSuggestion/Suggestion";
import { VehiclePool } from "../Scheduling/VehiclePool";
import { VehicleRatio } from "../VehicleSuggestion/VehicleRatio";
import { RunConfig } from "../../DataStructures/RunConfiguration/RunConfig";
import { UnitConverter } from "../unit-converter/UnitConverter";
import { RouteOptions } from "../../DataStructures/RunConfiguration/RouteOptions";
import { VehicleScheduler } from "../Scheduling/VehicleScheduler";
import { Injectable } from "@angular/core";
import { DirectionsService } from "../DirectionsService/DirectionsService";

@Injectable()
export class QuickAssignment{


    tripsWithRemainingPassengers;
    sortedTripsBySize : Array<Trip>;
    leftOvers :Array<Trip>;
    assigned:Array<Trip>;
    roundTripTime:number;
    scheduler:VehicleScheduler;
    runConfig:RunConfig;

    constructor(private vehicleService:VehicleService, private directionService:DirectionsService, private dialog:MatDialog){   
    }

    initialize(runConfig:RunConfig){
    }

    /**
     * Given the list of trips for the hour the vehicles will be assigned to each trip
     * @param runConfig 
     * @param trips 
     * @param localeDateString 
     * @param scheduler 
     * @returns 
     */
    assignVehiclesToTrips(runConfig:RunConfig,trips: Array<Trip>,localeDateString:string,scheduler:VehicleScheduler) : Promise<Array<Trip>>{

        this.runConfig = runConfig;
        this.roundTripTime = new UnitConverter().minuteToSecond(this.runConfig.roundTripTime)

        return new Promise( async (resolve,reject) =>{
            this.scheduler = scheduler;
            var poolOfReusableVehicles = this.scheduler.getAvailableVehiclesForTime(localeDateString);

            //Pass a list of vehicles that are available for the hour
            this.leftOvers = this.tryReusables(trips,poolOfReusableVehicles);

            if(this.leftOvers.length > 0){

                this.tryReserves(this.leftOvers,poolOfReusableVehicles).then(() =>{

                    resolve(this.assigned);
    
                }).catch(e =>{
    
                    reject(e);
                })
            }else{
                resolve(this.assigned);
            }
        })
    }

    tryReusables(trips:Array<Trip>,vehiclePool:VehiclePool) : Array<Trip>{

        var suggestions = VehicleSuggestion.getBestFitVehicles(trips,vehiclePool.reusables.getVehicles());
        this.leftOvers = new Array<Trip>();
        this.assigned = new Array<Trip>();
        this.seperateLeftOversAndAssigned(suggestions,false);
        return this.leftOvers;
    }

    seperateLeftOversAndAssigned(suggestions:Array<VehicleRatio>,reserves = false){

        suggestions.forEach(s =>{
            if(s.vehicle != null){
                s.trip.vehicleReservation = this.scheduler.getReservationForVehicle(s.vehicle.vehicleid);
                if(reserves){
                    s.trip.vehicleReservation.assignToNewTrip(s.trip);
                }else{
                    s.trip.vehicleReservation.assignAsReturnTrip(s.trip);
                }
                this.assigned.push(s.trip);
            }else{
                this.leftOvers.push(s.trip);
            }
        });
    }

    tryReserves(trips:Array<Trip>,vehiclePool:VehiclePool) : Promise<any>{

        return new Promise( async (resolve,reject) =>{
            var suggestions = VehicleSuggestion.getBestFitVehicles(trips,vehiclePool.reserves.getVehicles());
            this.leftOvers = new Array<Trip>();
            this.seperateLeftOversAndAssigned(suggestions,true);
            if(this.leftOvers.length > 0){
                await this.vehiclesNotReadilyAvailable(this.groupRemainingPassengersIntoOneTrip()).then(() =>{

                    resolve(null);

                }).catch(e =>{

                    reject(e);
                });
            }else{
                resolve(null);
            }
        })
    }

    private groupRemainingPassengersIntoOneTrip(): Trip {

 
        this.tripsWithRemainingPassengers = [];

        this.leftOvers.forEach(t => {
           
            this.tripsWithRemainingPassengers.push(t.copyTrip());
        })

        var newTrip = this.leftOvers.splice(0, 1)[0];
        newTrip.addTrips(this.leftOvers,true);
        return newTrip;
    }

    private vehiclesNotReadilyAvailable(tripWithRemainingPassengers): Promise<any> {

        return new Promise(async (resolve, reject) => {

            this.tripToIncludeRemainingPassengersOnRecieved(tripWithRemainingPassengers,null).then(() =>{
                resolve(null);
            }).catch(e => reject(e));
        })
    }

    private tripToIncludeRemainingPassengersOnRecieved(tripWithRemainingPassengers: Trip, tripToIncludeRemainingPassengersOn: Trip): Promise<any> {
        return new Promise(async (resolve, reject) => {

            var tripWithVehicleToWaitOn = null;
            var tripTimeForSecondOption = null;
            var tripWithVehicleToWaitOnCopy = null;
            var vehicleSuggestions: Array<Suggestion> = null;

            
            //Get Vehicle Suggestion
            await new VehicleSuggestion(this.vehicleService,this.runConfig).getSuggestions(this.tripsWithRemainingPassengers).then(suggestedVehicleTypes => {

                vehicleSuggestions = suggestedVehicleTypes;
                
            }).catch(e => {
                reject(e);
            })

            //get Trip Time For Secod Option
            if (tripWithVehicleToWaitOnCopy != null) {

                await tripWithVehicleToWaitOnCopy.getDirections(this.directionService,{
                    avoidTolls:RouteOptions.avoidTolls
                }).then(tripWithTime => {
                    tripTimeForSecondOption = Math.round(tripWithTime.time / 60);
                }).catch(e => {
                    reject(e);
                });
            }

            var createdVehicles : Array<Vehicle>;
            await this.vehicleService.createVehiclesFromSuggestions(vehicleSuggestions).then(res =>{
                createdVehicles = res;
            }).catch(e => { reject(e) });

            this.scheduler.addVehiclesToReservers(createdVehicles); 

            var counter = 0;


            vehicleSuggestions.forEach(s => {
                var vehicle = createdVehicles.find(v => v.runtimeid == s.vehicleReservation.vehicle.runtimeid);
                vehicle.remainingSeats = vehicle.capacity;
                s.trip.vehicleReservation = this.scheduler.getReservationForVehicle(vehicle.vehicleid);
                s.trip.vehicleReservation.assignToNewTrip(s.trip);
                this.assigned.push(s.trip);
                counter++;
            });
            resolve(null);
        })
    }

}